import React, { useEffect, useState } from "react";

/**
 * Floating value label shown while the user drags a position gizmo handle.
 * Style mirrors `LibraryDragHelperLabel` in App.jsx so drag feedback feels
 * consistent across the app.
 */
export default function PositionGizmoLabel() {
  const [label, setLabel] = useState(null);

  useEffect(() => {
    const onDrag = (event) => {
      const detail = event?.detail || {};
      const axisLetter = detail.axisLetter || "";
      const value = typeof detail.localValue === "number" ? detail.localValue : null;
      const clientX = typeof detail.clientX === "number" ? detail.clientX : null;
      const clientY = typeof detail.clientY === "number" ? detail.clientY : null;
      if (value == null || clientX == null || clientY == null) return;
      setLabel({
        axisLetter,
        value,
        clientX,
        clientY,
      });
    };
    const onDragEnd = () => setLabel(null);
    window.addEventListener("position-gizmo-drag", onDrag);
    window.addEventListener("position-gizmo-drag-end", onDragEnd);
    return () => {
      window.removeEventListener("position-gizmo-drag", onDrag);
      window.removeEventListener("position-gizmo-drag-end", onDragEnd);
    };
  }, []);

  if (!label) return null;

  return (
    <div
      className="pointer-events-none fixed z-[10000] inline-block rounded border border-gray-300/60 bg-gray-900/80 px-2 py-1 text-xs text-gray-100 shadow-md select-none whitespace-nowrap"
      style={{
        left: label.clientX,
        top: label.clientY,
        transform: "translate(14px, 14px)",
      }}
    >
      {`${label.axisLetter}: ${label.value.toFixed(3)}`}
    </div>
  );
}
